export const DEV_PATH = 'http://5b625a26e95c.ngrok.io';

export const BASE_PATH = 'https://sessionbase-backend-f5ytp.ondigitalocean.app';
//export const BASE_PATH = 'https://sessionbase.uc.r.appspot.com';

